import { FormControlLabel, Switch } from "@mui/material"
import React, { FC, Fragment, useState } from "react"
import { InputParameters } from "../InputParameters"

export interface InputSwitchProperties extends InputParameters<boolean> {
  color?: "primary" | "secondary" | "default" | undefined
  onChangeValue(value: boolean, name?: string): void
  key?: string
  value: boolean
}

const InputSwitch: FC<InputSwitchProperties> = ({
  label = "",
  color = "primary",
  size = "medium",
  onChangeValue = () => { },
  value,
  name = "input-switch",
  disabled = false,
  key,
}) => {
  const [checked, setChecked] = useState(false)

  React.useEffect(() => {
    setChecked(value)
  }, [value])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
    onChangeValue(event.target.checked, name)
  }

  return (
    <Fragment>
      <FormControlLabel
        disabled={disabled ? disabled : false}
        control={
          <Switch
            size={size}
            value={checked}
            onChange={handleChange}
            name={name}
            color={color}
            checked={checked}
          />
        }
        label={label}
      />
    </Fragment>
  )
}

export { InputSwitch }
